//改变对象的key名
//target:{old:new}
export const changeObjectName = (arr, target) => {
    let result = []
    for (let i = 0; i < arr.length; i++) {
        let obj = {}
        for (let item in arr[i]) {
            if (target.hasOwnProperty(item)) {
                obj[target[item]] = arr[i][item]
            } else {
                obj[item] = arr[i][item]
            }
        }
        result.push(obj)
    }
    return result
}

//设置sessionStorage过期时间
let setExpirationTime = (time) => {
    let timeNum = time ? time : 3
    let date = new Date()
    return date.getTime() + timeNum * 60 * 1000
}

//存储sessionStorage
export const setItem = (arr, value, time) => {
    let key = ''
    for (let i = 0; i < arr.length; i++) {
        key += arr[i] + '-'
    }
    if (time) {
        sessionStorage.setItem(key, JSON.stringify({ value, time: setExpirationTime(time) }))
    } else {
        sessionStorage.setItem(key, JSON.stringify({ value, time: setExpirationTime() }))
    }
}

//取localStorage
export const getLocalItem = (arr) => {
    let key = ''
    for (let i = 0; i < arr.length; i++) {
        key += arr[i] + '-'
    }
    if (localStorage.getItem(key) && new Date().getTime() > JSON.parse(localStorage.getItem(key)).time) {
        localStorage.removeItem(key)
    }
    if (localStorage.getItem(key)) {
        return JSON.parse(localStorage.getItem(key)).value
    }
    return false
}

//取sessionStorage
export const getItem = (arr) => {
    let key = ''
    for (let i = 0; i < arr.length; i++) {
        key += arr[i] + '-'
    }
    if (sessionStorage.getItem(key) && new Date().getTime() > JSON.parse(sessionStorage.getItem(key)).time) {
        sessionStorage.removeItem(key)
    }
    if (sessionStorage.getItem(key)) {
        return JSON.parse(sessionStorage.getItem(key)).value
    }
    return false
}

//获取服务端时间
export const getServerTime = () => {
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        if (!xhr) {
            xhr = new ActiveXObject("Microsoft.XMLHTTP")
        }
        xhr.open("HEAD", location.href, true)
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                resolve(xhr.getResponseHeader("Date"))
            }
        }
        xhr.send(null)
    })
}

//百分数转整数
export const percentToNumber = (arr, targe) => {
    let result = []
    for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        obj[targe] = Number(obj[targe].slice(0, -1))
        result.push(obj)
    }
    return result
}

//增加index序列
export const increaseIndex = (arr, start) => {
    if (start < 0) {
        start = 0
    }
    let result = []
    for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        obj.index = start + i
        result.push(obj)
    }
    return result
}

//将RGBA颜色转换为16进制的颜色
export const hexify = (color) => {
    var values = color
        .replace(/rgba?\(/, '')
        .replace(/\)/, '')
        .replace(/[\s+]/g, '')
        .split(',')
    var a = parseFloat(values[3] || 1),
        r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
        g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
        b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255)
    return "#" +
        ("0" + r.toString(16)).slice(-2) +
        ("0" + g.toString(16)).slice(-2) +
        ("0" + b.toString(16)).slice(-2)
}

//给每个饼状图按运营商分颜色
export const diffColor = (arr) => {
    let colorMap = {
        '电信': 'rgba(6, 198, 241, 1)',
        '移动': 'rgba(80, 227, 194, 1)',
        '联通': 'rgba(255, 115, 115, 1)',
        '其他': 'rgba(91, 97, 137, 1)'
    }
    for (var i = 0; i < arr.length; i++) {
        for (var item in colorMap) {
            if (arr[i].name.indexOf(item) > -1) {
                arr[i].itemStyle = {
                    color: colorMap[item]
                }
                break
            }
        }
    }
    return arr
}

//隐藏ip最后一位
export const hideIP = (ip) => {
    let arr = ip.split('.')
    let str = ''
    for (let i = 0; i < arr.length; i++) {
        if (i == 3) {
            str += "*"
        } else {
            str += arr[i] + '.'
        }
    }
    return str
}


//计算时间函数
const getsec = (str) => {
    var str1 = str.substring(1, str.length) * 1
    var str2 = str.substring(0, 1)
    if (str2 == "s") {
        // 统一成5分钟
        return 5 * 60 * 1000
        // return str1 * 1000;
    } else if (str2 == "h") {
        return str1 * 60 * 60 * 1000
    } else if (str2 == "d") {
        return str1 * 24 * 60 * 60 * 1000
    } else if (str2 == "m") {
        return str1 * 60 * 1000
    }
}
//获取cookie
export const getCookie = (name) => {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
    if (arr = document.cookie.match(reg))
        return unescape(arr[2])
    else
        return null
}

//设置cookie
export const setCookie = (name, value, time) => {
    var strsec = getsec(time)
    var exp = new Date()
    exp.setTime(exp.getTime() + strsec * 1)
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ';path=/;'
}

//1小时内只能埋点触发一次
export const isAllowPoint = (str) => {
    if (getCookie(str)) {
        return false
    } else {
        setCookie(str, str, 'h1')
        // setCookie(str, str, 'm1');
        return true
    }
}

//判断是否是Safari浏览器
export const isSafari = () => {
    var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
    return issafariBrowser
}

//判断是否是Firefox浏览器
export const isFirefox = () => {
    var userAgent = navigator.userAgent
    return userAgent.indexOf("Firefox") > -1 ? true : false
}

//判断是否是IE
export const isIE = () => {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return "IE"
    }
}

//判断是否是IE
export const isEdge = () => {
    var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
    if (userAgent.indexOf("Edge") > -1) {
        return true
    }
    return false
}

//植入广告
export const importAD = ({ id, className }) => {
    (window.slotbydup = window.slotbydup || []).push({
        id: id,
        container: className,
        async: true
    })
}

//判断是否是mac
export const isMac = () => {
    var isMac = /macintosh|mac os x/i.test(navigator.userAgent)
    if (isMac) {
        return true
    }
    return false
}

//判断是否要隐藏滚动条
export const hideScrollBar = () => {
    var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
    if (userAgent.indexOf("Firefox") > -1) {
        return true
    } //判断是否Firefox浏览器
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return true
    } //判断是否IE浏览器
    if (userAgent.indexOf("Edge") > -1) {
        return true
    }
    return false
}

//判断是否要放大logo
export const blowLogo = () => {
    var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
    if (userAgent.indexOf("Firefox") > -1) {
        return true
    } //判断是否Firefox浏览器
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return true
    } //判断是否IE浏览器
    return false
}

//移除value为0的项
export const moveNone = (arr) => {
    return arr.filter((val) => {
        return val.value != 0
    })
}


export const locationList = {
    '山东': [118.527663, 36.09929],
    '河北': [115.661434, 38.61384],
    '吉林': [126.262876, 43.678846],
    '黑龙江': [128.047414, 47.356592],
    '辽宁': [122.753592, 41.6216],
    '内蒙古': [114.415868, 43.468238],
    '中国新疆': [85.614899, 42.127001],
    '甘肃': [102.457625, 38.103267],
    '宁夏': [106.155481, 37.321323],
    '山西': [112.515496, 37.866566],
    '陕西': [109.503789, 35.860026],
    '河南': [113.486804, 34.157184],
    '安徽': [117.216005, 31.859252],
    '江苏': [119.368489, 33.013797],
    '浙江': [119.957202, 29.159494],
    '福建': [117.984943, 26.050118],
    '广东': [113.394818, 23.408004],
    '江西': [115.676082, 27.757258],
    '海南': [109.733755, 19.180501],
    '广西': [108.924274, 23.552255],
    '贵州': [106.734996, 26.902826],
    '湖南': [111.720664, 27.695864],
    '湖北': [112.410562, 31.209316],
    '四川': [102.89916, 30.367481],
    '云南': [101.592952, 24.864213],
    '中国西藏': [89.137982, 31.367315],
    '青海': [96.202544, 35.499761],
    '天津': [117.210813, 39.14393],
    '上海': [121.487899, 31.249162],
    '重庆': [106.530635, 29.544606],
    '北京': [116.395645, 39.929986],
    '中国台湾': [120.961454, 23.80406],
    '中国香港': [114.186124, 22.293586],
    '中国澳门': [113.557519, 22.204118],
    "全国": [106.395645, 35.929986]
}

export const zoomList = {
    '山东': 7,
    '河北': 7,
    '吉林': 7,
    '黑龙江': 6,
    '辽宁': 7,
    '内蒙古': 5,
    '中国新疆': 5,
    '甘肃': 7,
    '宁夏': 7,
    '山西': 7,
    '陕西': 7,
    '河南': 7,
    '安徽': 7,
    '江苏': 7,
    '浙江': 7,
    '福建': 7,
    '广东': 7,
    '江西': 7,
    '海南': 8,
    '广西': 7,
    '贵州': 7,
    '湖南': 7,
    '湖北': 7,
    '四川': 6,
    '云南': 7,
    '中国西藏': 6,
    '青海': 6,
    '天津': 9,
    '上海': 9,
    '重庆': 8,
    '北京': 9,
    '中国台湾': 7,
    '中国香港': 10,
    '中国澳门': 10,
    "全国": 4
}
